import { render, staticRenderFns } from "./CredenciamentoFornecedorEdital.vue?vue&type=template&id=1692b716"
import script from "./CredenciamentoFornecedorEdital.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorEdital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports